// extracted by mini-css-extract-plugin
export default {"logosHeading":"Logos_logosHeading__gEJ6W","logosWrapper":"Logos_logosWrapper__Xqc2S","logoWrapper":"Logos_logoWrapper__PrKUh"};